import { isBefore, parseISO } from 'date-fns';

export type LojaId = number;

export type EmissaoRange = {
  ini?: string | Date | null;
  fim?: string | Date | null;
};

export type ValidateSearchInput = {
  lojas: LojaId[];
  emissao: EmissaoRange;
};

export type ValidateSearchResult =
  | { ok: true }
  | { ok: false; errors: string[] };

/**
 * Valida critérios obrigatórios para pesquisa.
 *
 * Regras:
 * 1) Pelo menos uma loja selecionada.
 * 2) Período de emissão informado (ini e fim) e Data Final >= Data Inicial.
 *
 * @param input Critérios da pesquisa (lojas e período de emissão)
 * @returns Resultado da validação com `ok` e lista de `errors` quando inválido
 */
export function validateSearch(
  input: ValidateSearchInput,
): ValidateSearchResult {
  const errors: string[] = [];

  // Regra 1: ao menos uma loja
  if (!Array.isArray(input.lojas) || input.lojas.length === 0) {
    errors.push('Selecione ao menos uma loja.');
  }

  // Regra 2: emissao ini/fim e intervalo válido
  const { ini, fim } = input.emissao ?? {};
  if (!ini || !fim) {
    errors.push('Informe a Data Inicial e a Data Final da emissão.');
  } else {
    const start = typeof ini === 'string' ? parseISO(ini) : ini;
    const end = typeof fim === 'string' ? parseISO(fim) : fim;

    if (Number.isNaN(start?.getTime()) || Number.isNaN(end?.getTime())) {
      errors.push('Período de emissão inválido.');
    } else if (isBefore(end, start)) {
      errors.push('A Data Final deve ser maior ou igual à Data Inicial.');
    }
  }

  return errors.length ? { ok: false, errors } : { ok: true };
}
